import React from 'react'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
import {FooterContainer, FooterWrap, FooterLinksContainer, FooterLinksWrapper, 
FooterLinkItems, FooterLinkTitle, FooterLink, SocialIconLink, SocialIcons,
SocialLogo, SocialMedia, WebsiteRights, SocialMediaWrap} from "./FooterElement"
import {animateScroll as scroll} from "react-scroll";

const Footers = () => {
        const toggleHome =()=>{
            scroll.scrollToTop()
        }
        return (
            <FooterContainer>
                <FooterWrap>
                    <FooterLinksContainer>
                        <FooterLinksWrapper>
                            <FooterLinkItems>
                                <FooterLinkTitle>I<span style={{color:"crimson", fontStyle:"italic"}}>D</span>ev</FooterLinkTitle>
                                    <FooterLink>1234 your address here</FooterLink>
                                    <FooterLink>Opening Times</FooterLink>
                                    <FooterLink>Monday- Friday: 8am-4pm</FooterLink>
                                    <FooterLink>Saturday-Sunday:Closed</FooterLink>
                            
                            </FooterLinkItems>
                            
                        </FooterLinksWrapper>
    
                        <FooterLinksWrapper>
                            <FooterLinkItems>
                                <FooterLinkTitle>Quick Link</FooterLinkTitle>
                                    <FooterLink to="/">Home</FooterLink>
                                    <FooterLink to="/services">Services</FooterLink>
                                    <FooterLink to="/about">About</FooterLink>
                                    <FooterLink to="/contacts">Contact Us</FooterLink>
                                 
                            </FooterLinkItems>
                            </FooterLinksWrapper>
                            <FooterLinksWrapper>
                            
                        </FooterLinksWrapper>
                    </FooterLinksContainer>
               
                    <SocialMedia>
                        <SocialMediaWrap>
                            <SocialLogo to="/" onClick={toggleHome}>
                            I<span style={{color:"crimson", fontStyle:"italic"}}>D</span>ev
                            </SocialLogo>
                            
                            <SocialIcons>
                                <SocialIconLink href="/" target="_blank" aria-label="Facebook">
                                    <FaFacebook/>
                                </SocialIconLink>
                                <SocialIconLink href="/" target="_blank" aria-label="Instagram">
                                    <FaInstagram/>
                                </SocialIconLink>
                                <SocialIconLink href="/" target="_blank" aria-label="Twitter">
                                    <FaTwitter/>
                                </SocialIconLink>
                                <SocialIconLink href="/" target="_blank" aria-label="LinkedIn">
                                    <FaLinkedin/>
                                </SocialIconLink>
                            </SocialIcons>
                            <WebsiteRights>I<span style={{color:"crimson", fontStyle:"italic"}}>D</span>ev {new Date().getFullYear()} All rights reserved.</WebsiteRights>
                        </SocialMediaWrap>
                    </SocialMedia>
                </FooterWrap>
            </FooterContainer>
    )
}

export default Footers
